import { useScreenMessage } from '../../Message';

export const useEditPreset = (process) => {
  const { showErrorMessage, showSuccessMessage } = useScreenMessage();

  return (name, params) =>
    process(params)
      .then((response) => {
        showSuccessMessage(`«${name}» preset updated`);
        return response;
      })
      .catch((e) => {
        showErrorMessage(e.message, { multiple: Array.isArray(e.message) });
        return Promise.reject(e);
      });
};
